export const brandColors = {
  black: '#000000',
  white: '#f0ede8',
  grey: '#9BA2AE',
  purple: '#3d405b',
  blue: '#3D405B',
  orange: '#F46036',
  lightblue: '#0CBABA',
  yellow: '#F2F709'
};

export const fonts = {
  monterrat: 'Montserrat',
  athelas: 'athelas'
};

const breakpoints = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '640px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
};

export const fixPoints = {
  oneMin: '(min-width: 1313px)',
  oneMax: '(max-width: 1312px)',
  twoMin: '(min-width: 756px)',
  twoMax: '(max-width: 754px)',
  threeMin: `(min-width: ${breakpoints.tablet})`,
  threeMax: `(max-width: ${breakpoints.laptop})`
};

export const device = {
  mobileS: `(min-width: ${breakpoints.mobileS})`,
  mobileM: `(min-width: ${breakpoints.mobileM})`,
  mobileL: `(min-width: ${breakpoints.mobileL})`,
  tablet: `(min-width: ${breakpoints.tablet})`,
  tabletRotated: `(min-width: ${breakpoints.laptop}) and (orientation : landscape)`,
  laptop: `(min-width: ${breakpoints.laptop})`,
  laptopL: `(min-width: ${breakpoints.laptopL})`,
  desktop: `(min-width: ${breakpoints.desktop})`,
  desktopL: `(min-width: ${breakpoints.desktop})`,
  pixelRatio: `(min-width: ${breakpoints.laptop}) and (-webkit-min-device-pixel-ratio: 1.5)`
};



// WEBPACK FOOTER //
// ./src/styles/variables.js